import { render, staticRenderFns } from "./AllowTuiPopup.vue?vue&type=template&id=c8e1ee76&scoped=true"
import script from "./AllowTuiPopup.vue?vue&type=script&lang=js"
export * from "./AllowTuiPopup.vue?vue&type=script&lang=js"
import style0 from "./AllowTuiPopup.vue?vue&type=style&index=0&id=c8e1ee76&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e1ee76",
  null
  
)

export default component.exports